import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

import { useSlotContext } from '../../utils/useSlotContext';
import { CardTitle } from './CardTitle';
import { CardDescription } from './CardDescription';
import { DEFAULT_CARD_DIRECTION } from './Card.constants';
import { GRID_AREA_CONTENT } from './Card.styleUtils';

type CardContentProps = {
    title?: ReactNode;
    description?: ReactNode;
    children?: ReactNode;
    sx?: SxProps<Theme>;
};

export const CardContent = (props: CardContentProps) => {
    const { direction = DEFAULT_CARD_DIRECTION } = useSlotContext(
        props,
        'card',
    );

    const isVerticalActions = direction === 'vertical-actions';

    return (
        <Stack
            gap={0.25}
            alignItems="flex-start"
            sx={{
                ...(isVerticalActions && { gridArea: GRID_AREA_CONTENT }),
                ...props.sx,
            }}
        >
            {props.title && <CardTitle>{props.title}</CardTitle>}
            {props.description && (
                <CardDescription>{props.description}</CardDescription>
            )}
            {props.children}
        </Stack>
    );
};
